import { render, staticRenderFns } from "./SectionFile.vue?vue&type=template&id=76a7e154&"
import script from "./SectionFile.vue?vue&type=script&lang=js&"
export * from "./SectionFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports